define('home/views/ChannelBannerView',[
    'backbone-marionette',

    'home/mixins/withChannelBanner',
    'home/mixins/withClickLinkTracking',

    'home/templates/channelBanner',
], function (
    Marionette,

    withChannelBanner,
    withClickLinkTracking,

    channelBannerTemplate
) {
    'use strict';

    var ChannelBannerView = Marionette.ItemView.extend({
        template: channelBannerTemplate,

        events: {
            'click a': 'trackClickLink',
        },
    });

    var proto = ChannelBannerView.prototype;

    withClickLinkTracking.call(proto, 'channel_top_banner');
    withChannelBanner.call(proto);

    return ChannelBannerView;
});

